import React from 'react';
import PropTypes from 'prop-types';

export default function ReCenterButton({ onButtonClicked }) {
  return (
    <button
      type="button"
      onClick={onButtonClicked}
      style={{
        position: 'absolute',
        left: '10px',
        bottom: '130px',
        width: '40px',
        height: '40px',
        cursor: 'pointer',
        background: 'rgb(255, 255, 255)',
        borderColor: 'rgb(255, 255, 255)',
      }}
    >
      <i className="fa fa-map-marker" />
    </button>
  );
}

ReCenterButton.propTypes = {
  onButtonClicked: PropTypes.func.isRequired,
};
